<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS74EC2']['10'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-sm-3 control-label">{{ labels['HRMS74EC2']['20'] }}</label>
                  <div class="col-sm-2">
                    <div class="form-control readonly-field-color">{{ setYearOutput(indexSelected.dteyear) }}</div>
                  </div>
                  <label class="col-sm-2 control-label">{{ labels['HRMS74EC2']['30'] }}</label>
                  <div class="col-sm-3">
                    <div class="form-control readonly-field-color">{{ indexSelected.codcours }} - {{ indexSelected.desc_codcours }}</div>
                  </div>                
                </div>
              </form>

              <!-- <table class="table table-condensed" style="margin-top: 30px;">
                <thead style="font-size: 16px;">
                  <tr>
                    <th style="min-width:60px; text-align:center;">{{ labels['HRMS74EC2']['40'] }}</th>
                    <th style="min-width:200px; text-align:center;">{{ labels['HRMS74EC2']['50'] }}</th>
                    <th style="min-width:100px;">{{ labels['HRMS74EC2']['60'] }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align:center;">{{ detail.tab1.numseq1 }}</td>
                    <td><input type="checkbox"  value="Y" v-model="detail.tab1.conbsc"  disabled="disabled" /> <label>{{ labels['HRMS74EC2']['70'] }}</label></td>
                    <td>{{ detail.tab1.cond1 }}</td>
                  </tr>
                  <tr>
                    <td style="text-align:center;">{{ detail.tab1.numseq2 }}</td>
                    <td><input type="checkbox"  value="Y" id="concours" v-model="detail.tab1.concours" disabled="disabled" /> <label>{{ labels['HRMS74EC2']['80'] }}</label></td>
                    <td>{{ detail.tab1.cond2 }}</td>
                  </tr>
                  <tr>
                    <td style="text-align:center;">{{ detail.tab1.numseq3 }}</td>
                    <td><input type="checkbox"  value="Y" v-model="detail.tab1.conspc" disabled="disabled" /> <label>{{ labels['HRMS74EC2']['90'] }}</label></td>
                    <td>{{ detail.tab1.cond3 }}</td>
                  </tr>
                  <tr>
                    <td style="text-align:center;">{{ detail.tab1.numseq4 }}</td>
                    <td><input type="checkbox"  value="Y" v-model="detail.tab1.flgretrn" disabled="disabled" /> <label>{{ labels['HRMS74EC2']['100'] }}</label></td>
                    <td>{{ detail.tab1.cond4 }}</td>
                  </tr>
                  <tr>
                    <td style="text-align:center;">{{ detail.tab1.numseq5 }}</td>
                    <td><input type="checkbox"  value="Y" v-model="detail.tab1.flgretrn2" disabled="disabled" /> <label>{{ labels['HRMS74EC2']['110'] }}</label></td>
                    <td>{{ detail.tab1.cond5 }}</td>
                  </tr>
                </tbody>
              </table>

              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-sm-3 control-label">{{ labels['HRMS74EC2']['120'] }}</label>
                  <div class="col-sm-3">
                    <div class="form-control readonly-field-color">{{ detail.tab1.dtelsttr }}</div>
                  </div>                 
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">               
                  <label class="col-sm-3 control-label">{{ labels['HRMS74EC2']['130'] }}</label>
                  <div class="col-sm-3">
                    <textarea id="desnote" name="desnote" class="form-control" readonly="readonly">{{ detail.tab1.v_logical }} </textarea>
                  </div>                 
                  <label class="col-sm-2 control-label">{{ labels['HRMS74EC2']['140'] }}</label>
                  <div class="col-sm-3">
                    <textarea id="desnote" name="desnote" class="form-control" readonly="readonly">{{ detail.tab1.v_syncond }} </textarea>
                  </div>                 
                </div>
              </form> -->
              <form class="form-horizontal">
                <div class="form-group margin-b-5">              
                  <label class="col-sm-3 control-label">สรุปเงื่อนไข</label>
                  <div class="col-sm-7">
                    <textarea id="desnote" name="desnote" class="form-control" readonly="readonly">{{ detail.tab1.v_plncond }} </textarea>
                  </div>                    
                </div>
              </form>


            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['STDTHISTRN']['10'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <form class="form-horizontal">
                <div class="form-group">
                  <label class="col-sm-4 control-label">{{ labels['STDTHISTRN']['20'] }}</label>
                  <div class="col-sm-3">
                    <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
                  </div>
                </div>
              </form>

              <hrms-table :columns="tab2Table" :data="detail.tab2" />

            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS74EC4']['10'] }}
          </h3>
        </div>
        <div id="details3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-sm-4 control-label">{{ labels['HRMS74EC4']['20'] }}</label>
                  <div class="col-sm-2">
                    <div class="form-control readonly-field-color">{{ setYearOutput(indexSelected.dteyear) }}</div>
                  </div>
                  <label class="col-sm-1 control-label">{{ labels['HRMS74EC4']['30'] }}</label>
                  <div class="col-sm-2">
                    <div class="form-control readonly-field-color">{{ descMonth(indexSelected.dtemonth) }}</div>
                  </div>                  
                </div>
              </form>

              <form class="form-horizontal">
                <div class="form-group  margin-b-5">
                  <label class="col-sm-4 control-label">{{ labels['HRMS74EC4']['40'] }}</label>
                  <div class="col-sm-2">
                    <div class="form-control readonly-field-color">{{ indexSelected.numclseq }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group">
                  <label class="col-sm-4 control-label">{{ labels['HRMS74EC4']['50'] }}</label>
                  <div class="col-sm-5">
                    <div class="form-control readonly-field-color">{{ indexSelected.codcours }} - {{ indexSelected.desc_codcours }}</div>
                  </div>
                </div>
              </form>

              <hrms-table :columns="tab3Table" :data="detail.tab3" />

            </div>
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">
      <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import configLabels from 'src/../config/label'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms74e-detail',
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'indexSelected', 'nowLang', 'tab2Table', 'tab3Table' ],
  methods: {
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    },
    descMonth (monthNo) {
      if (typeof monthNo !== 'undefined') {
        return configLabels.month[this.nowLang][monthNo - 1].full
      } else {
        return ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?51326676